<template>
  <component :is="allSitesMode ? 'BaseLayout' : 'AdminLayout'">
    <template #content>
      <UserShowView :all-sites-mode="allSitesMode" />
    </template>
  </component>
</template>

<script>
import UserShowView from './UserShowView.vue';

export default {
  name: 'UserShowPage',
  components: { UserShowView },
  props: { allSitesMode: { type: Boolean, default: false } },
};
</script>
